<template>
  <el-dialog
    :title="openMarkTitle"
    :width="dialogWidth"
    @open="initData"
    :close-on-click-modal="false"
    :visible.sync="visible"
    :before-close="handleCancel">
    <div class='pj-box' :class='pjStatus == "tryout" ? "tryout-box" : "regular-box"'>
      <div class="body">
        <div class="tryout-body" v-if='pjStatus == "tryout"'>
          <span class='pj-tips'>开启正式评卷后，评卷参数将不能修改，但可以调整评卷老师。</span>
          <p>如果评卷过程中有评阅标准错误的问题，可以进行"重新评卷"。</p>
          <p class='check-plan-link'><span>评卷方案</span><a @click="checkPlan">查看</a> </p>
          <div class="progress" :class='submitLoading ? "roll" : ""'></div>
        </div>
        <div class="regular-body" v-else>
          <select-mark-item ref="select-mark-item" :examId='examId' :subject='{subjectId,subjectName}' :markItems='itemStatus' :type="true"/>
        </div>
      </div>
      <div slot="footer" v-if='pjStatus.length !== 0' style="text-align: center">
        <el-button type="success" v-if='pjStatus == "tryout"' :disabled="submitLoading" @click="handleSave">开启</el-button>
        <el-button type="info" @click="handleCancel">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import SelectMarkItem from '@/views/exam/open-pre-mark/SelectMarkItem'
import { getItemInfo, getItemStructure } from '@/model/item-model'
import {queryExamMonitor} from '@/model/exam-manager-model'
import { changePjStatus } from '@/model/pj-server-model'
export default {
  name: 'OpenMark',
  components: {
    SelectMarkItem
  },
  props: {
    subjectId: {
      type: String,
      required: true
    },
    examId: {
      type: String,
      required: true
    },
    examName: {
      type: String,
      required: true
    },
    subjectName: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // 状态 tryout - 开始正评,regular - 可以开启重评 rejudge - 重评中
      pjStatus: '',
      checkStatusLoadng: true,
      divId: [],
      itemStatus: [],
      submitLoading: false
    }
  },
  created () {
    this.initData()
  },
  computed: {
    openMarkTitle () {
      return '开启正评/重评' + this.examName
    },
    dialogWidth () {
      if (this.pjStatus === 'tryout') {
        return '480px'
      } else {
        return '980px'
      }
    }
  },
  methods: {
    initData () {
      let param = {
        examId: this.examId,
        subjectId: this.subjectId
      }
      let result = {}
      // 异常对象
      let exceptionObject = {message: '未检测到主观题'}
      return getItemInfo({data: param}).then(infoRes => {
        if (infoRes.result === 'false') {
          this.alertError(infoRes.errorMsg || '请检查是否开启试评')
          return
        }
        result.item = infoRes.data
        if (infoRes.length === 0) {
          throw exceptionObject
        } else {
          return queryExamMonitor(param).then(res => {
            let monitorItem = res.data[0].monitorItems.find((monitorItem) => {
              return monitorItem.monitorName === '开启试评'
            })
            if (monitorItem.monitorProcess.toString() !== '1') {
              exceptionObject.message = '请检查是否开启试评'
              throw exceptionObject
            }
          })
        }
      }).then(() => {
        getItemStructure(param).then(structureRes => {
          result.itemStructure = structureRes
          var items = result.item !== undefined ? result.item : []
          for (let item of items) {
            if (item.type === 'zg') {
              this.divId.push(item.name)
            }
          }
          // 初始化
          // 查询是否可以开启正评 并取第一题的评卷状态
          this.initDetalListen()
        })
      }).catch(err => {
        this.alertError(err.message || '请检查是否开启试评')
        this.checkStatusLoadng = false
      })
    },
    initDetalListen () {
      let param = {
        examId: this.examId,
        subjectId: this.subjectId,
        divId: this.divId,
        status: ''
      }
      changePjStatus(param).then(pjRes => {
        if (pjRes.result !== 'false') {
          this.pjStatus = pjRes[0].status
          this.itemStatus = pjRes
          console.log(this.itemStatus)
        } else {
          this.alertError(pjRes.errDesc || '请检查是否开启试评')
        }
        this.checkStatusLoadng = false
      }).catch(err => {
        console.log(err)
        this.alertError(err.message || '请检查是否开启试评')
        this.checkStatusLoadng = false
      })
    },
    checkPlan () {
      var _previewUrl = `/view/setting_preview.html?examId=${this.examId}&subjectId=${this.subjectId}&examName=${escape(this.examName)}&subjectName=${escape(this.subjectName)}&enterFlag=1`
      window.open(_previewUrl)
    },
    handleSave () {
      this.submitLoading = true
      let param = {
        examId: this.examId,
        subjectId: this.subjectId,
        divId: this.divId,
        status: 'regular'
      }
      changePjStatus(param).then(pjRes => {
        this.submitLoading = false
        if (pjRes.length > 0) {
          this.alertSuccess('您已经成功开启正式评卷！')
        } else {
          this.alertError(pjRes.errDesc || '开启正试评卷失败，请稍后再试！')
        }
      }).catch(err => {
        console.log(err)
        this.alertError('开启正试评卷失败，请稍后再试！')
        this.submitLoading = false
      })
    },
    /**
     * 处理取消弹窗点击事件
     * 弹出页面改动将不会提交的提示，确定则返回首页
     */
    handleCancel () {
      this.$emit('dialog-close', {})
    },

    /**
     * 错误弹窗
     */
    alertError (errorMsg) {
      const h = this.$createElement
      let tipEls = [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--warning`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--warning']
        }, errorMsg)
      ]
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, tipEls)
      this.$alert(vnode, '', {
        confirmButtonText: '我知道了',
        center: true,
        showClose: false,
        showCancelButton: false,
        confirmButtonClass: 'kw-alert__confirm-button kw-alert__confirm-button--success',
        callback: action => {
          this.$emit('dialog-close', {})
        }
      })
    },

    // 成功弹窗
    alertSuccess (msg) {
      const h = this.$createElement
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--success`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--success']
        }, msg)
      ])
      this.$alert(vnode, '', {
        confirmButtonText: '确定',
        center: true,
        showClose: false,
        showCancelButton: false,
        callback: action => {
          this.$emit('dialog-close', {examId: this.examId, operate: 'updateTaskMonitor'})
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .pj-tips{
    display: inline-block;
  }

  .pj-box{
    overflow: hidden;
    color: #606266;
    .title{
      height: 40px;
      line-height: 40px;
      padding-left: 20px;
      background: #469064;
      color: #fff;
      position: relative;
      i{
        position: absolute;
        right: 15px;
        top: 12px;
        font-size: 16px;
      }
    }
    .body{
      .tryout-body{
        width: 350px;
        margin: 0 auto 30px;
      }
      .regular-body{
        margin-bottom: 20px;
      }
    }
    .foot{
      margin: 10px auto;
      text-align: center;
      button{
        margin: 0 15px;
      }
    }
  }
  .pj-box.tryout-box{
    .body{
      margin-top: 20px;
    }
    .foot{
      margin: 44px auto 20px;
    }
  }
  .check-plan-link{
    text-align: left;
    span{
      width: 80px;
      display: inline-block;
      border-right: 1px solid #ddd;
      margin-right: 12px;
      line-height: 14px;
    }
    a{
      color: #606266;
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .progress{
    width: 100%;
    height: 20px;
    margin: 40px auto 0;
  }
  .roll{
    height: 20px;
    background: repeating-linear-gradient(45deg,#d0dbc2,#d0dbc2 .7rem,#b7c9a1 .7rem,#b7c9a1 1.2rem);
    animation: roll 0.7s infinite linear;
  }
  @keyframes roll{
    0% {
      background-position: 40px 0px;
    }
    100% {
      background-position: 0px 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/exam/open-mark/OpenMark.vue